import { RootState } from '../../../../rootReducer';

export const settingsSelector = (state: RootState) => state.aboutModuleReducer.SettingsReducer;
